import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { DashboardService } from '../../business-services/dashboard.service';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { NgxSpinnerService } from 'ngx-spinner';
import { PagerData } from '../../business-entities/PagerData';
import { Constant } from '../../../../../Autofacets-Core/src/app/utils/constant';
import { Filter } from '../../business-entities/Filter';
import { PaginationService } from '../../services/pagination.service';
import { LaborDetailsViewModel } from '../../business-entities/labor-details-view-model';
import { LaborService } from '../../business-services/labor.service';
import { SortEvent, NgbdSortableHeader } from '../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { CookieService } from 'ngx-cookie-service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddEditLaborComponent } from './add-edit-labor/add-edit-labor.component';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { BrandService } from '../../business-services/brand.service';
import { TranslateService } from '@ngx-translate/core';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { ToastrService } from 'ngx-toastr';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { ApplicationSourceService } from '../../business-services/application-source.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-labor',
  templateUrl: './labor.component.html'
})
export class LaborComponent implements OnInit {
  SyncList: StatusViewModel[] = [];
  StatusList: StatusViewModel[] = [];
  userRoleRightsDetails: UserRoleMenu;
  laborList: LaborDetailsViewModel[] = [];
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25//Constant.GridPagerSize
  }
  dataRows: any[] = [];
  pager: any = {};
  pagedItems: any[];
  filterItems: any[];
  filter: Filter = new Filter();
  throttle = 100;
  scrollDistance = 1;
  selectedStatus: number;
  selectedSync: number;
  sourceName:string;
  searchTerm: string;
  brandList: BrandViewModel[];
  applicationSourceList: any[] = [];
  popupCloseResult = false;
  subscription : Subscription;
  allowDealerBrandLaborRate:boolean = false;

  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
  {
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    moduleId: Enums.ModuleNames.Service,
    logDate: '',
    referenceId: 0
  };
  isDmsSyncLabor : boolean = false;
  currentlagSub: Subscription;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private laborService: LaborService,
    private dashboardService: DashboardService,
    private userService: UserDataService,
    private spinner: NgxSpinnerService,
    private pagerService: PaginationService,
    private cookieservice: CookieService,
    private applicationSourceService: ApplicationSourceService,
    private modalService: NgbModal,
    private brandService: BrandService,
    private translate: TranslateService,
    private dmsService: DMSSyncFailedlogService,
    private toaster: ToastrService,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage,
  ) { }

  ngOnInit(): void {
    if (this.selectedStatus != undefined) {
      this.laborService.laborListRequest.statusId = this.selectedStatus;
    }
    if (this.selectedSync != undefined) {
      this.laborService.laborListRequest.syncId = this.selectedSync;
    }
    this.laborService.laborListRequest.cultureCode = this.cookieservice.get('userSelectedLanguage');
    this.StatusList = this.dashboardService.getStatusList();
    this.SyncList = this.dashboardService.getDmsStatusList();
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Labor);
    this.getFeatures();
    this.GetApplicationSource();
    this.laborService.laborListRequest.startRecordNumber = 0;
    this.laborList = [];
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.laborService.laborListRequest.cultureCode=x;
      this.getBrands().then(()=>{
        this.getLaborList();
      });
    });

    
  }
  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }
  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if(features == null || features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        features = res;
        if (features?.length > 0) {
          this.allowDealerBrandLaborRate = features.find(x => x.featureCode === Enums.FeatureCode.AllowDealerBrandLaborRate)?.isActive;
          this.isDmsSyncLabor = features.find(x => x.featureCode === Enums.FeatureCode.RTDSL)?.isActive
        }
      })
    }else{
      this.allowDealerBrandLaborRate = features.find(x => x.featureCode === Enums.FeatureCode.AllowDealerBrandLaborRate)?.isActive;
      this.isDmsSyncLabor = features.find(x => x.featureCode === Enums.FeatureCode.RTDSL)?.isActive
    }
  }

  async getLaborList() {
    this.spinner.show();
    await this.laborService.getLaborList(this.laborService.laborListRequest).then((response) => {
      this.spinner.hide();
      this.laborList.push(...this.laborDataMapper(response.responseObject.laborList));
      if (response.responseObject?.result?.errorCode == "5449") {
        this.totalCount = 0;
      }
      else {
        this.totalCount = this.laborList.length > 0 ? this.laborList[0].totalCount : 0;
      }
      this.resetPagerData(this.supplierInitiliseGridFromServer(this.laborList, this.totalCount));
      if (this.pagerData.page > 1) {
        this.resetPagerData(this.initilisePagerFromServer(this.pagerData.page, this.pagerData.pagerSize, this.totalCount));
      }

    },_error => {
      this.spinner.hide();
    });
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  initilisePagerFromServer(page: number, _pageSize: number, count: number = this.filterItems.length) {
    let length = this.filterItems.length <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = (data.length === 0) ? 0 : 1;
    return this.initilisePagerFromServer(this.filter.page, Number(this.filter.pageSize), count);
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.laborService.laborListRequest.sortColumn = column;
    this.laborService.laborListRequest.sortDirection = direction;
    this.laborService.laborListRequest.startRecordNumber = 0;
    this.laborList = []
    this.getLaborList();
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.laborList.length){
      this.laborService.laborListRequest.startRecordNumber = this.laborList.length;
      this.getLaborList();
    }
  }

  StatusChange(status: any) {
    if (status == undefined) {
      this.laborService.laborListRequest.statusId = Enums.StatusCode.All;
    } else {
      this.laborService.laborListRequest.statusId = status;
    }
    this.laborService.laborListRequest.startRecordNumber = 0;
    this.laborList = [];
    this.getLaborList();
  }

  SyncChange(status: any) {
    if (status == undefined) {
      this.laborService.laborListRequest.syncId = Enums.DmsSync.All;
    } else {
      this.laborService.laborListRequest.syncId = status;
    }
    this.laborService.laborListRequest.startRecordNumber = 0;
    this.laborList = [];
    this.getLaborList();
  }

  SourceChange(status: any) {
    this.laborService.laborListRequest.sourceId = status;
    this.laborService.laborListRequest.startRecordNumber = 0;
    this.laborList = [];
    this.getLaborList();
  }

  onRefresh() {
    this.laborService.laborListRequest.startRecordNumber = 0;
    this.laborService.laborListRequest.sourceId = 0; 
    this.laborList = [];
    this.sourceName = null;
    this.selectedSync = null;
    this.selectedStatus = null;
    this.getLaborList();
  }

  onSearchFilter() {
    this.laborService.laborListRequest.startRecordNumber = 0;
    this.laborService.laborListRequest.searchTerm = this.searchTerm;
    this.laborList = []
    this.getLaborList();
  }

  onEdit(id: number) {
    this.laborService.Id = id;
    const modalref = this.modalService.open(AddEditLaborComponent, { size: 'lg', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  private laborDataMapper(labor: any) {
    let supperArray = [];
    if (labor && labor.length > 0) {

      for (let index = 0; index < labor.length; index++) {
        const element = labor[index];

        let single = Object();
        single.rowNumber = (this.laborService.laborListRequest.startRecordNumber + 1) + index;
        single.id = element.id
        single.laborNo = element.laborNo
        single.name = element.name
        single.makeName = element.makeName
        single.duration = element.duration ? +element.duration : 0;
        single.fixedPrice = element.fixedPrice
        single.sourceType = element.sourceType
        single.dmsSyncStatus = element.dmsSyncStatus
        single.isActive = element.isActive
        single.activeStatus = element.activeStatus
        single.updatedDate = element.updatedDate ? new Date(element.updatedDate + 'Z') : null;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.createdDate = element.createdDate ? new Date(element.createdDate + 'Z') : null;
        single.totalCount = element.totalCount
        single.logo = element.makeCode
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  onSyncToDms(Id){
    let modelHeadermsg = this.translate.instant("lblSyncToDMS");
    let modelBodymsg = this.translate.instant("lblSureToSync");
    let errorMsg = this.translate.instant('lblErrormsg');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      //this is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        this.laborService.ResyncLabor(Id).then((response) => {
          this.spinner.hide();
          if (response.responseObject.isSuccess) {
            let successMsg = this.translate.instant('lblSyncSuccess')
            this.toaster.success(successMsg);
            this.laborList = [];
            this.laborService.laborListRequest.startRecordNumber = 0;
            this.getLaborList();
          } else {
            this.spinner.hide();
            this.toaster.error(errorMsg);
          }
        });
      }
    });
  }
  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  viewException(Id){
    this.dmsLogRequestModel.referenceId = Id;
    this.spinner.show();
    let errorMsg = this.translate.instant('lblNoErrorDetails');
    this.dmsService.GetDmsSyncFailedLog(this.dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.spinner.hide();
        if (response.responseObject.length > 0) {
          let ex = response.responseObject[0].exceptionMessage;

          let modelHeadermsg = this.translate.instant("lblException");
          const modalRef = this.modalService.open(NgInfoModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = ex;
          modalRef.result.then((_result) => { 
             // This is intentional
          }, (reason) => {
            this.popupCloseResult = this.getDismissDeleteReason(reason);
          });
        } else {
          this.toaster.error(errorMsg);
        }
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  getBrandImage(key: any) {
    return this.brandList?.filter(
      (x) => x.brandCode.toUpperCase() === key.toUpperCase()
    )[0];
  }

  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = data.responseObject;
      this.applicationSourceList = this.applicationSourceList.filter(source => source.sourceId === Enums.SourceId.Planner || source.sourceId === Enums.SourceId.DMS);
    });
  }
 
  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve()
      });
    })
  }
}
